import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'padstart'
})
export class PadstartPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
